'use strict'

const DEFAULT_TITLE = 'MatchHub - ';

var exports = {
    DEFAULT_TITLE
};

export default exports;